<!--
 * @Author: AnNa
 * @Date: 2020-06-06 11:14:12
 * @LastEditors: AnNa
 * @LastEditTime: 2021-05-13 14:51:29
 * @Description: 
-->
<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 0, 18, 0]">
        <slot name="tooltip"></slot>
        <v-smooth-area position="x*y" />
      </v-chart>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
// const data = []
// const beginDay = new Date().getTime()

// for (let i = 0; i < 10; i++) {
//   data.push({
//     x: moment(new Date(beginDay + 1000 * 60 * 60 * 24 * i)).format('YYYY-MM-DD'),
//     y: Math.round(Math.random() * 10),
//   })
// }
// console.log(data)

const scale = [
  {
    dataKey: 'x',
    min: 2,
  },
  {
    dataKey: 'y',
    title: '时间',
    min: 1,
    max: 22,
  },
]

export default {
  name: 'MiniArea',
  data() {
    return {}
  },
  props: {
    data: {
      type: Array,
      default: [],
    },

    scale: Array,
    height: {
      type: Number,
      default: 100,
    },
  },
}
</script>

<style lang="less" scoped>
@import 'chart';
</style>
